import { useLocation } from 'react-router-dom';
import { HelpCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { useHelpContent } from '@/hooks/useHelpContent';
import { useHelpDrawerStore } from '@/stores/useHelpDrawer';
import { HelpDrawer } from '@/components/help/HelpDrawer';

export function HelpButton() {
  const { pathname } = useLocation();
  const content = useHelpContent(pathname);
  const open = useHelpDrawerStore((s) => s.open);
  const setOpen = useHelpDrawerStore((s) => s.setOpen);
  const disabled = !content;

  return (
    <>
      <div className="fixed bottom-20 right-4 z-40 md:bottom-6 md:right-6">
        <Tooltip>
          <TooltipTrigger asChild>
            <span>
              <Button
                type="button"
                size="icon"
                variant="secondary"
                disabled={disabled}
                onClick={() => setOpen(true)}
                aria-label={disabled ? 'No hay ayuda para esta pantalla' : 'Abrir ayuda contextual (Ctrl+?)'}
                className="h-11 w-11 rounded-full shadow-lg border border-border bg-card hover:bg-accent"
              >
                <HelpCircle className="h-5 w-5" />
              </Button>
            </span>
          </TooltipTrigger>
          <TooltipContent side="left">
            {disabled ? 'No hay ayuda para esta pantalla' : `Ayuda: ${content?.title}`}
          </TooltipContent>
        </Tooltip>
      </div>
      <HelpDrawer
        open={open && !disabled}
        onOpenChange={setOpen}
        content={content}
      />
    </>
  );
}
